<template>
  <v-card class="tabella-conti elevation-4">
    <v-card-title v-if="filters">
      <v-bottom-sheet inset v-model="filtersWindow">
        <template v-slot:activator>
          <v-btn class="table-filters" fab dark small color="primary">
            <v-icon dark>{{ isFiltering ? 'mdi-filter-remove' : 'mdi-filter'}}</v-icon>
          </v-btn>
        </template>
        <v-toolbar tabs>
          <v-toolbar-title>Filtri</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="clearFilters" flat icon>
            <v-icon>mdi-filter-remove-outline</v-icon>
          </v-btn>
          <template v-slot:extension>
            <v-tabs
              ref="tabs"
              mandatory
              v-model="activeFilter"
              color="transparent">
              <v-tab
                :key="i"
                v-for="(currF, i) in filtersToRender"
                class="primary--text">
                <v-badge
                  color="red"
                  overlap
                  :value="(filtersValues[currF.t] || []).length > 0"
                  right>
                  <template v-slot:badge>
                    <span>{{(filtersValues[currF.t] || []).length}}</span>
                  </template>
                  <span>{{currF.d}}</span>
                </v-badge>
              </v-tab>
            </v-tabs>
            <div v-if="showFilterWindow" class="filter-window">
              <v-text-field
                clearable
                class="search-field"
                v-model="filterSearchField"
                @input="paginatedFilter && debounce(refreshFilter, 1500)"
                label="Cerca"
                hide-details
                autofocus
                @blur="showFilterWindow = false"
                @click:clear="showFilterWindow = false; refreshFilter()"
              ></v-text-field>
            </div>
            <v-btn color="info"
              v-if="activeFilter !== null && filtersToRender[activeFilter].f"
              @click="showFilterWindow = !showFilterWindow" flat icon>
              <v-icon>mdi-filter</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
        <v-tabs-items class="table-filter-container" v-model="activeFilter">
          <v-tab-item
            :key="i"
            v-for="(currF, i) in filtersToRender">
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-btn
                  @click="setFilterValue(
                    currF.t,
                    v.value,
                    currF.m,
                  )"
                  round
                  color="primary"
                  :outline="!(filtersValues[currF.t] || [])
                    .includes(v.value)"
                  :class="{'active': (filtersValues[currF.t] || [])
                    .includes(v.value)}"
                  :key="i" v-for="(v, i) in filtered(currF.t, currF.data)">
                  {{ v.text }}
                </v-btn>
                <v-btn
                  color="info"
                  round
                  :disabled="!currF.lm"
                  :loading="loadingMore"
                  @click="triggerLoadMore(currF.t)"
                  v-if="currF.p"> Carica ancora.... </v-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-bottom-sheet>
      <v-layout v-if="textFilter">
        <v-flex sm8 xs12>
          <v-text-field
            label="Cerca..."
            single-line
            v-model="textSearch"
            @input="debounce(refresh, 1500)"
            clearable
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="data.rows"
      :pagination.sync="pagination"
      :total-items="data.totalRows"
      :loading="loading"
      :rows-per-page-items="[5, 10, 50]">
      <!-- ROW -->
      <template v-slot:items="props">
        <tr
          :class="{ clickable: rowClickable }"
          @click="rowClickable && rowDetail(props.item)">
          <template v-if="preset == 'venduto'">
            <td>
              <div v-if="multiMode" :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.id_documento_associato }}</td>
            <td>{{ props.item.data_ora | date }}</td>
            <td>{{ props.item.tipo_documento | documento }}</td>
            <td class="text-xs-right">{{ props.item.coperti }}</td>
            <td class="text-xs-right">{{ props.item.totale | currency }}</td>
          </template>
          <template v-if="preset == 'venduto-articoli'">
            <td v-if="mostraCodiciArticolo">
              <div v-if="multiMode" :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.cod_articolo }}</td>
            <td>
              <div
                v-if="multiMode && !mostraCodiciArticolo"
                :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.descrizione }}</td>
            <td class="text-xs-right">{{ props.item.sum_quantita }}</td>
            <td class="text-xs-right">{{ props.item.sum_totale | currency }}</td>
          </template>
          <template v-if="preset == 'ordinato'">
            <td>
              <div v-if="multiMode" :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.numero_comanda }}</td>
            <td>{{ props.item.data_ora | date }}</td>
            <td>{{ props.item.cameriere }}</td>
            <td>{{ props.item.nome_tavolo }}</td>
            <td class="text-xs-right">{{ props.item.totale | currency }}</td>
          </template>
          <template v-if="preset == 'ordinato-articoli'">
            <td v-if="mostraCodiciArticolo">
              <div v-if="multiMode" :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.cod_articolo }}</td>
            <td>
              <div
                v-if="multiMode && !mostraCodiciArticolo"
                :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.descrizione }}</td>
            <td class="text-xs-right">{{ props.item.sum_quantita }}</td>
            <td class="text-xs-right">{{ props.item.sum_totale | currency }}</td>
          </template>
          <template v-if="preset == 'storni'">
            <td>
              <div v-if="multiMode" :class="['locale', coloreLocale(props.item.locale)]">
                <span>
                  <div class="inner white--text">
                    {{ descrLocale(props.item.locale) }}
                  </div>
                </span>
              </div>
              {{ props.item.data_ora | date }}</td>
            <td>{{ props.item.descrizione }}</td>
            <td>{{ props.item.cameriere }}</td>
            <td>{{ props.item.nome_tavolo }}</td>
            <td class="text-xs-right">{{ props.item.quantita }}</td>
            <td class="text-xs-right">{{ props.item.totale | currency }}</td>
          </template>
        </tr>
      </template>
      <!-- FOOTER -->
      <template v-if="totals && preset == 'venduto'" v-slot:footer>
        <td class="text-xs-right" colspan="3">Totali</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.coperti', 0) }}</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.totale', 0) | currency }}</td>
      </template>
      <template v-else-if="totals && preset == 'venduto-articoli'" v-slot:footer>
        <td class="text-xs-right" :colspan="mostraCodiciArticolo ? 2 : 1">Totali</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.quantita', 0) }}</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.totale', 0) | currency }}</td>
      </template>
      <template v-else-if="totals && preset == 'ordinato'" v-slot:footer>
        <td class="text-xs-right" colspan="4">Totale</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.totale', 0) | currency }}</td>
      </template>
      <template v-else-if="totals && preset == 'ordinato-articoli'" v-slot:footer>
        <td class="text-xs-right" :colspan="mostraCodiciArticolo ? 2 : 1">Totali</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.quantita', 0) }}</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.totale', 0) | currency }}</td>
      </template>
      <template v-else-if="totals && preset == 'storni'" v-slot:footer>
        <td class="text-xs-right" colspan="4">Totali</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.quantita', 0) }}</td>
        <td class="text-xs-right subheading">{{ $get(data, 'totals.totale', 0) | currency }}</td>
      </template>
    </v-data-table>
    <component ref="rowDetail" :is="rowDetailComp"></component>
  </v-card>
</template>

<script>
import ld from 'lodash';

import Stats from '@/mixins/stats';
import RowDetailConto from '@/components/row-details/RowDetailConto.vue';
import RowDetailRiga from '@/components/row-details/RowDetailRiga.vue';
import RowDetailComanda from '@/components/row-details/RowDetailComanda.vue';
import { FiltroGruppo } from '@/components/filtri';

export default {
  name: 'tcloud-datatable',
  mixins: [Stats],
  components: { RowDetailConto, FiltroGruppo },
  props: {
    limit: Boolean,
    totals: Boolean,
    filters: Boolean,
    textFilter: Boolean,
    name: {
      type: String,
      required: true,
    },
    preset: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      textSearch: '',
      pagination: {
        sortBy: null,
        descending: true,
      },
      headers: [],
      filtersValues: {},
      filter: [],
      rowClickable: false,
      rowDetailComp: null,

      enabledFilters: [],
      activeFilter: null,
      filtersWindow: false,

      filterSearchField: '',
      debounceTimeout: null,
      loadingMore: false,
      showFilterWindow: false,
    };
  },
  watch: {
    pagination: {
      handler(newV, oldV) {
        if ('page' in oldV) this.refresh();
      },
      deep: true,
    },
    activeFilter(newV, oldV) {
      if (oldV !== null && this.filterSearchField !== '') {
        this.filterSearchField = '';
        this.refreshFilter(oldV);
      }
    },
    filtersWindow(show) {
      if (show) {
        setTimeout(() => {
          this.$refs.tabs.onResize();
        }, 200);
      } else {
        this.refresh();
      }
    },
  },
  mounted() {
    const extraFilters = this.moduli.map(mod => mod.toLowerCase());
    switch (this.preset) {
      case 'venduto':
        this.headers = [
          { text: 'Numero', value: 'id_documento_associato' },
          { text: 'Data ora', value: 'data_ora' },
          { text: 'Tipo documento', value: 'tipo_documento' },
          { align: 'right', text: 'Coperti', value: 'coperti' },
          { align: 'right', text: 'Totale', value: 'totale' },
        ];
        this.enabledFilters = [
          'chiusura',
          'tipoDocumento',
          'cameriere',
          'sala',
          'tavolo',
          'ragioneSociale',
        ];
        this.pagination.sortBy = 'data_ora';
        this.rowClickable = true;
        this.rowDetailComp = RowDetailConto;
        break;
      case 'venduto-articoli':
        this.headers = [
          ...(this.mostraCodiciArticolo ? [{ text: 'Cod. articolo', value: 'cod_articolo' }] : []),
          { text: 'Descrizione', value: 'descrizione' },
          { align: 'right', text: 'Quantità', value: 'sum_quantita' },
          { align: 'right', text: 'Valore', value: 'sum_totale' },
        ];
        this.enabledFilters = ['cameriere', 'sala', 'tavolo', 'gruppo', ...extraFilters];
        this.pagination.sortBy = 'sum_quantita';
        this.rowClickable = true;
        this.rowDetailComp = RowDetailRiga;
        break;
      case 'ordinato':
        this.headers = [
          { text: 'Comanda', value: 'numero_comanda' },
          { text: 'Data ora', value: 'data_ora' },
          { text: 'Cameriere', value: 'cameriere' },
          { text: 'Tavolo', value: 'nome_tavolo' },
          { align: 'right', text: 'Totale', value: 'totale' },
        ];
        this.enabledFilters = ['cameriere', 'sala', 'tavolo'];
        this.pagination.sortBy = 'data_ora';
        this.rowClickable = true;
        this.rowDetailComp = RowDetailComanda;
        break;
      case 'ordinato-articoli':
        this.headers = [
          ...(this.mostraCodiciArticolo ? [{ text: 'Cod. articolo', value: 'cod_articolo' }] : []),
          { text: 'Descrizione', value: 'descrizione' },
          { align: 'right', text: 'Quantità', value: 'sum_quantita' },
          { align: 'right', text: 'Valore', value: 'sum_totale' },
        ];
        this.enabledFilters = ['cameriere', 'sala', 'tavolo', 'gruppo', ...extraFilters];
        this.pagination.sortBy = 'sum_quantita';
        this.rowClickable = false;
        this.rowDetailComp = null;
        break;
      case 'storni':
        this.headers = [
          { text: 'Data ora', value: 'data_ora' },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Cameriere', value: 'cameriere' },
          { text: 'Tavolo', value: 'nome_tavolo' },
          { align: 'right', text: 'Quantità', value: 'quantita' },
          { align: 'right', text: 'Totale', value: 'totale' },
        ];
        this.enabledFilters = ['cameriere', 'sala', 'tavolo', 'gruppo'];
        this.pagination.sortBy = 'data_ora';
        this.rowClickable = false;
        this.rowDetailComp = null;
        break;
      default:
        break;
    }
    if (this.filters) this.loadFilters();
  },
  methods: {
    debounce(fn, timeout) {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(fn, timeout);
    },
    rowDetail(item) {
      this.$refs.rowDetail.show(item);
    },
    async triggerLoadMore(filtro) {
      this.loadingMore = true;
      await this.loadMore([
        filtro,
        this.filterSearchField,
      ]);
      this.loadingMore = false;
    },
    setFilterValue(key, value, multi) {
      if (!this.filtersValues[key]) {
        this.$set(this.filtersValues, key, []);
      }
      const i = this.filtersValues[key].indexOf(value);
      if (i !== -1) {
        if (multi) {
          this.filtersValues[key].splice(i, 1);
        } else {
          this.filtersValues[key] = [];
        }
      } else if (multi) {
        this.filtersValues[key].push(value);
      } else {
        this.filtersValues[key] = [value];
      }
    },
    clearFilters() {
      this.filtersValues = {};
    },
    async refresh() {
      this.loading = true;
      const extraSettings = {
        totals: this.totals,
        filters: ld.pickBy(this.filtersValues, v => v.length > 0),
        textSearch: this.textSearch,
      };
      if (this.limit) extraSettings.limit = 200;
      await this.datatableReload([this.name, this.preset, {
        ...this.pagination,
        ...extraSettings,
      }]);
      this.loading = false;
    },
    async refreshFilter(filtro = null) {
      if (this.paginatedFilter) {
        this.loadingMore = true;
        await this.filterSearch([
          this.filtersToRender[filtro !== null ? filtro : this.activeFilter].t,
          this.filterSearchField,
        ]);
        this.loadingMore = false;
      } else {
        this.filterSearchField = '';
      }
    },
    filtered(filtro, data) {
      if (this.activeFilter === null) return [];
      if (!this.paginatedFilter) {
        return data.filter(({ text }) => text.toLowerCase()
          .indexOf((this.filterSearchField || '').toLowerCase()) !== -1);
      }
      return data;
    },
  },
  computed: {
    data() {
      return this.datatable(this.name);
    },
    isFiltering() {
      return Object.values(this.filtersValues).some(v => v.length > 0);
    },
    filtersToRender() {
      return this.filtri.filter(filtro => this.enabledFilters.includes(filtro.t));
    },
    paginatedFilter() {
      return this.activeFilter !== null && this.filtersToRender[this.activeFilter].p;
    },
  },
};
</script>

<style lang="stylus" scoped>
.tabella-conti
  width 100%
.filter-list
  overflow auto
  max-height 200px
tr
  .locale
    position absolute
    left 0
    height 100%
    top 0
    max-width 2px
    will-change max-width
    transition max-width .4s
    display: flex;
    justify-content: center;
    align-items: center;
    span
      white-space nowrap
      opacity 0
      .inner
        transition width .4s
        width 0%
        overflow hidden
        padding 0 20px
  &:hover
    .locale
      max-width 100%
      span
        opacity 1
        .inner
          width 100%
.table-filters
  position absolute
  margin 0
  right 10px
  top -20px
.table-filter-container
  height calc(100vh / 2)
  background #ddd
  overflow auto
  z-index 1
.filter-window
  position absolute
  top 122px
  right 10px
  padding 10px
  background #f5f5f5
  box-shadow 0 2px 4px -1px rgba(0,0,0,.2),
             0 4px 5px 0 rgba(0,0,0,.14),
             0 1px 10px 0 rgba(0,0,0,.12)
</style>
